import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { distinctUntilKeyChanged, take } from 'rxjs/operators';
import { AppConfig } from 'src/app/helpers/app.config';
import { Consultant } from 'src/app/models/consultant.model';
import { Invitation, InvitationSearch } from 'src/app/models/invitation.model';
import { Pagination } from 'src/app/models/pagination.model';
import { Profile } from 'src/app/models/profile.model';
import { Children, Project } from 'src/app/models/project';
import { fromConsultant } from 'src/app/reducers/consultant.reducer';
import { fromInvitationsSearch } from 'src/app/reducers/invitations-search.reducer';
import { fromInvitations } from 'src/app/reducers/invitations.reducer';
import { IdealProfileService } from 'src/app/services/ideal-profile.service';
import { ReportService } from 'src/app/services/report.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'ct-export-reports',
  templateUrl: './export-reports.component.html',
  styleUrls: ['./export-reports.component.scss']
})
export class ExportReportsComponent implements OnInit, OnDestroy {

  @ViewChild('exportReportsModal') exportReportsModal;

  modalRef: NgbModalRef;
  closeResult: string;
  HCC: number[] = [];
  clientId: number;
  idealProfilesNr = [];
  idealProfilesIp = [];
  idealProfileSelectedIp: Profile = undefined;
  idealProfileSelectedNr: Profile = undefined;
  officeId: number;
  ctOfficeId: number;
  projects: Project[] = [];
  currentInvitationSearch: InvitationSearch;
  currentInvitations: Pagination<Invitation>;
  showSelectNr = true;
  showSelectIp = true;
  showLoader = false;
  onlyEvalualia = false;

  consultant$: Observable<Consultant>;
  invitations$: Observable<Pagination<Invitation>>;
  invitationSearch$: Observable<InvitationSearch>;

  currentConsultant: Consultant;
  multipleSubscription: Subscription;

  exportReportForm: FormGroup = this.fb.group({
    reportType: [2, Validators.required],
    adjustmentNr: [false],
    adjustmentIp: [false],
    idealProfileIp: [],
    idealProfileNr: [],
    reportLanguageId: [1, Validators.required],
    projectId: [null]
  });

  constructor(
    public modal: NgbModal,
    private fb: FormBuilder,
    private idealProfileService: IdealProfileService,
    private store: Store,
    public utilsService: UtilsService,
    private reportService: ReportService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {

    this.consultant$ = this.store.pipe(select(fromConsultant.selectConsultantState));
    this.invitationSearch$ = this.store.pipe(select(fromInvitationsSearch.selectInvitationsSearchState));
    this.invitations$ = this.store.pipe(select(fromInvitations.selectInvitationsState));

    this.HCC = AppConfig.settings.OFFICES_WITH_PROJECTS.split(',').map(officeId => Number(officeId));

    this.multipleSubscription = combineLatest([
      this.invitationSearch$,
      this.consultant$.pipe(distinctUntilKeyChanged('office')),
      this.invitations$
    ]).subscribe(([invitationSearch, consultant, invitations]) => {

      this.officeId = consultant.office.randstadOffice;
      this.ctOfficeId = consultant.office.id;
      this.clientId = consultant.client.id;
      this.currentConsultant = consultant;

      this.exportReportForm.controls.reportLanguageId.setValue(consultant.client.id);

      if (this.HCC.includes(this.officeId)) {
        this.projects = consultant.projects;
      }

      this.currentInvitationSearch = invitationSearch;
      this.currentInvitations = invitations;

      if (invitationSearch.testModel.length && !invitationSearch.testModel.includes(1 as any) && !invitationSearch.testModel.includes(2 as any) && !invitationSearch.testModel.includes(24 as any)) {
        this.onlyEvalualia = true;
      }

      if (invitationSearch.createdBy === 'office') {
        if (consultant.office.businessAreaIds.includes(1) && !consultant.office.businessAreaIds.includes(2)) {
          this.showSelectNr = true;
          this.showSelectIp = false;
        } else if (!consultant.office.businessAreaIds.includes(1) && consultant.office.businessAreaIds.includes(2)) {
          this.showSelectNr = false;
          this.showSelectIp = true;
        }
      } else if (invitationSearch.testModel.length) {
        if (invitationSearch.testModel.includes(1 as any) && !invitationSearch.testModel.includes(2 as any)) {
          this.showSelectNr = true;
          this.showSelectIp = false;
        } else if (!invitationSearch.testModel.includes(1 as any) && invitationSearch.testModel.includes(2 as any)) {
          this.showSelectNr = false;
          this.showSelectIp = true;
        } else if (!invitationSearch.testModel.includes(1 as any) && !invitationSearch.testModel.includes(2 as any)) {
          this.showSelectNr = false;
          this.showSelectIp = false;
        }
      } else {
        this.showSelectNr = true;
        this.showSelectIp = true;
      }
    });

  }

  open() {
    if (!this.modal.hasOpenModals()) {
      this.modalRef = this.modal.open(this.exportReportsModal,
        { ariaLabelledBy: 'Ver-Competencias', centered: true, backdrop: 'static', keyboard: false, size: 'xl' }
      );
      this.getAllIdealProfiles(this.ctOfficeId, 1);
      this.modalRef.result.then((result) => {
        this.closeResult = 'Closed with: ' + result;
      }, (reason) => {
        // this.closeResult = 'Dismissed ' + this.getDismissReason(reason);
      });
    }
  }

  getAllIdealProfiles(officeId: number, languageId: number) {
    this.idealProfileService.getByBussines(1, officeId, languageId, this.clientId).pipe(take(1)).subscribe(res => {
      res.map(profile => {
        if (profile.isUb) {
          profile.name = this.translateService.instant('JOBTYPES.' + (profile.jobtype?.randstadJobtype ?? 0))
        }
      })
      console.log(res);

      this.idealProfilesNr = res;
    });

    this.idealProfileService.getByBussines(2, officeId, languageId, this.clientId).pipe(take(1)).subscribe(res => {
      res.map(profile => {
        if (profile.isUb) {
          profile.name = this.translateService.instant('JOBTYPES.' + (profile.jobtype?.randstadJobtype ?? 0))
        }
      })
      this.idealProfilesIp = res;
    });
  }

  getExportReport() {
    this.showLoader = true;
    const reportParams = {
      ...this.currentInvitationSearch,
      ...this.exportReportForm.value,
      consultantOfficeId: this.ctOfficeId,
      clientId: this.currentConsultant.client.id
    };

    if (reportParams.reportType === 1) {
      reportParams.adjustmentNr = null;
      reportParams.adjustmentIp = null;
      reportParams.idealProfileIp = null;
      reportParams.idealProfileNr = null;
    }

    const cleanReportParams = this.utilsService.cleanParams(reportParams);

    this.reportService.getExportReports(cleanReportParams).subscribe(excel => {
      const downloadLink = document.createElement('a');
      downloadLink.href = excel;
      downloadLink.download = '';
      downloadLink.click();
      this.showLoader = false;
    }, error => {
      this.utilsService.toast('error', 'Unexpected', true, this.utilsService.getNacsData({ endpoint: 'GET' + AppConfig.settings.API + ' /export/reports', body: cleanReportParams, error: { errorType: error.errorType, errorCode: error.errorCode, message: error.message } }));
      this.showLoader = false;
    });
  }

  ngOnDestroy(): void {
    this.multipleSubscription.unsubscribe();
  }

}
